// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'EditorialNew', 'EditorialNew Fallback'"},"className":"__className_b87a8a","variable":"__variable_b87a8a"};